import { UserRoles } from './UserRoles'

const { ROLE_OPERATOR: _, ROLE_NORMAL: __, ...forbidden } = UserRoles

export const ForbiddenUserRoles = forbidden
export type ForbiddenUserRoles = (typeof ForbiddenUserRoles)[keyof typeof ForbiddenUserRoles]
